import React, { useEffect, useState } from 'react'

import { Icon } from '../../components/Icon'

import {
  UserDetailsApiResponse,
  UserDetailsApiResponseObj,
  verifyUserResponse,
} from '../../utils/types'
import { toast } from 'react-toastify'
import { getUsers, verifyUser } from '../../api/admin/settings'
import { useQuery } from 'react-query'

import Loading from '../../components/UI/Loading'
import { capitalizeFirstLetter } from '../../utils/utils'
import Modal from '../../components/UI/UIModal'
import UISwitch from '../../components/UI/UISwitch'
import UIButton from '../../components/UI/UIButton'

export interface password {
  oldPassword: string
  newPassword: string
}

const Users = () => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [userId, setUserId] = useState<string>('')
  const [isEmailSend, setIsEmailSend] = useState<boolean>(false)
  const [isEmailSendLoader, setIsEmailSendLoader] = useState<boolean>(false)

  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('status')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  console.log('isEmailSend', isEmailSend)

  const getUsersData = async (
    currentPage: number,
    sortBy: string,
    sortOrderValue: string
  ): Promise<UserDetailsApiResponseObj> => {
    const response = (await getUsers(
      currentPage,
      sortBy,
      sortOrderValue
    )) as UserDetailsApiResponse

    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    //  console.log(' newSortOrder[key]', key)
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      //  console.log(' newSortOrder[testjdjsn]', newSortOrder[key])
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }
  const users = useQuery('users', () =>
    getUsersData(currentPage, sortBy, sortOrderValue)
  )

  const handleVerifyUser = async (
    isEmailSend: boolean,
    uId: string,
    verificationStatus: string
  ) => {
    try {
      setIsEmailSendLoader(true)
      const response = (await verifyUser(
        uId,
        verificationStatus,
        isEmailSend
      )) as verifyUserResponse
      toast.success(response?.status, {
        position: 'top-right',
      })
      setIsEmailSendLoader(false)
      handleCloseModal()
      setIsEmailSend(false)
      users.refetch()
    } catch (error) {
      setIsEmailSendLoader(false)
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const handlePageChange = (pageNumber: number): void => {
    setCurrentPage(pageNumber)
  }
  useEffect(() => {
    users.refetch()
    handlePageChange(1)
  }, [currentPage])

  useEffect(() => {
    users.refetch() // Refetch incidents when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  const handleCloseModal = () => {
    setIsOpen(false)
    setIsEmailSend(false)
  }

  return (
    <>
      <div
        style={{
          height: 'calc(100vh - 100px)',
          overflow: 'auto',
          scrollbarWidth: 'none',
        }}
      >
        <div className="flex my-4 h-[80%] gap-2 ">
          {/* First column */}
          <>
            <div
              id={'#container'}
              // className="w-full flex justify-center items-center"
              className="w-full  flex justify-center items-baseline relative overflow-scroll"
            >
              {/* table component */}
              <div className="overflow-hidden w-full flex flex-col gap-[3px]">
                <div className="bg-gray2 w-full rounded-xl flex">
                  <div className="px-4 py-3 w-[25%] flex items-center border-r-2 border-r-white">
                    <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                      Name
                    </p>
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        handleSort('firstName')
                      }}
                    >
                      <Icon
                        name={'IconChevronDown'}
                        width={16}
                        height={16}
                        strokeWidth={1}
                        stroke={'#67A5B9'}
                      />
                    </div>
                  </div>
                  <div className="px-4 py-3 w-[28%] flex items-center border-r-2 border-r-white">
                    <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                      Email
                    </p>
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        handleSort('email')
                      }}
                    >
                      <Icon
                        name={'IconChevronDown'}
                        width={16}
                        height={16}
                        strokeWidth={1}
                        stroke={'#67A5B9'}
                      />
                    </div>
                  </div>
                  <div className="px-4 py-3 w-[18%] flex items-center border-r-2 border-r-white">
                    <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                      Role
                    </p>
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        handleSort('role')
                      }}
                    >
                      <Icon
                        name={'IconChevronDown'}
                        width={16}
                        height={16}
                        strokeWidth={1}
                        stroke={'#67A5B9'}
                      />
                    </div>
                  </div>
                  <div className="px-4 py-3 w-[18%] flex items-center border-r-2 border-r-white">
                    <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                      Account Status
                    </p>
                    <div
                      className="cursor-pointer"
                      onClick={() => {
                        handleSort('status')
                      }}
                    >
                      <Icon
                        name={'IconChevronDown'}
                        width={16}
                        height={16}
                        strokeWidth={1}
                        stroke={'#67A5B9'}
                      />
                    </div>
                  </div>
                  <div className="px-4 py-3 w-[18%] flex items-center border-r-2 border-r-white">
                    <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                      Verification Status
                    </p>
                  </div>
                  {/* {localStorage.getItem('userRole') === 'Safeguarding Lead' && ( */}
                  {localStorage.getItem('userRole') == 'Admin / DSL' && (
                    <div className="px-4 py-3 w-[18%] flex items-center border-r-2 border-r-white">
                      <p className="text-sm font-semibold leading-6 text-text1 flex-1">
                        Actions
                      </p>
                    </div>
                  )}
                  {/* )} */}
                </div>
                {users.isLoading ? (
                  <div className="flex h-[100%] w-[100%] justify-center items-center p-[10px]">
                    <Loading size="large" />
                  </div>
                ) : (
                  <div className=" flex flex-col  gap-[3px]">
                    {users?.data?.data?.map((item) => {
                      return (
                        <>
                          <div className="bg-gray1 w-full rounded-xl flex">
                            <div className="px-4 py-2 w-[25%] flex items-center border-r-2 h-13 border-r-white gap-2">
                              <div className="flex items-center justify-center rounded-full bg-bluishGreen text-white w-10 h-10 border-4 border-[#FFFFFF33]">
                                <p className="text-xs text-white font-medium">
                                  {item?.userName?.charAt(0)?.toUpperCase()}
                                  {/*  {item?.userName.charAt(1)?.toUpperCase() */}
                                </p>
                              </div>

                              <div>
                                <div className="flex-1 flex flex-row">
                                  <p className="text-sm font-semibold leading-6 text-text2 w-24 overflow-hidden whitespace-nowrap overflow-ellipsis">
                                    {item?.userName}
                                  </p>
                                  {/* <p className="text-xs font-medium leading-5 text-text3">
                                {item?.name?.lastName}
                              </p> */}
                                </div>
                                <p className="text-xs font-medium leading-5 text-bluishGreen">
                                  {item?.firstName}
                                </p>
                              </div>
                            </div>
                            <div className="px-4 py-2 w-[28%] flex items-center border-r-2 h-13 border-r-white">
                              <div className="rounded-[40px] bg-gray3 p-2 px-3">
                                <p className="text-xs font-medium leading-5 text-bluishGreen">
                                  {item?.email}
                                </p>
                              </div>
                            </div>
                            <div className="px-4 py-2 w-[18%] flex items-center border-r-2 h-13 border-r-white">
                              <div className="rounded-[40px] bg-gray3 p-2 px-3">
                                <p className="text-xs font-medium leading-5 text-bluishGreen">
                                  {item?.role}
                                </p>
                              </div>
                            </div>
                            <div className="px-4 py-2 w-[18%] flex items-center border-r-2 h-13 border-r-white">
                              <div className="flex flex-1 items-center gap-2">
                                <div className="flex-1">
                                  {item?.status == 'active' ? (
                                    <div className="rounded-[40px] w-fit bg-lightGreen p-2 px-3">
                                      <p className="text-xs font-medium leading-5 text-text2">
                                        {capitalizeFirstLetter(item?.status)}
                                      </p>
                                    </div>
                                  ) : (
                                    <div className="rounded-[40px] w-fit bg-gray2 p-2 px-3">
                                      <p className="text-xs font-medium leading-5 text-text1">
                                        {capitalizeFirstLetter(item?.status)}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="px-4 py-2 w-[18%] flex items-center border-r-2 h-13 border-r-white">
                              <div className="flex flex-1 items-center gap-2">
                                <div className="flex-1">
                                  {item?.verificationStatus == null ? (
                                    <div className="rounded-[40px] w-fit bg-gray2 p-2 px-3">
                                      <p className="text-xs font-medium leading-5 text-text1">
                                        {capitalizeFirstLetter(item?.status)}
                                      </p>
                                    </div>
                                  ) : (
                                    <div className="rounded-[40px] w-fit bg-gray2 p-2 px-3">
                                      <p className="text-xs font-medium leading-5 text-text1">
                                        {item?.verificationStatus}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            {localStorage.getItem('userRole') ==
                              'Admin / DSL' && (
                              <div className="px-4 py-3 w-[18%] flex items-center border-r-2 border-r-white">
                                {item?.verificationStatus ==
                                  'Awaiting-Verification' && (
                                  <div className="flex gap-3">
                                    <div
                                      onClick={() => {
                                        setUserId(item?.userId)
                                        setIsOpen(true)
                                      }}
                                      className="bg-[#CCF0E8] w-8 h-8 flex items-center justify-center rounded-full cursor-pointer"
                                    >
                                      <Icon
                                        name={'IconCheck'}
                                        width={16}
                                        height={16}
                                        strokeWidth={1.5}
                                        stroke={'#01B38B'}
                                      />
                                    </div>
                                    <div
                                      onClick={() => {
                                        handleVerifyUser(
                                          isEmailSend,
                                          item?.userId,
                                          'Failed'
                                        )
                                      }}
                                      className="bg-[#FFD8D8] w-8 h-8 flex items-center justify-center rounded-full cursor-pointer"
                                    >
                                      <Icon
                                        name={'IconCross'}
                                        width={10}
                                        height={10}
                                        strokeWidth={1.5}
                                        stroke={'#FF6666'}
                                      />
                                    </div>
                                  </div>
                                )}
                                {item?.verificationStatus == null && (
                                  <div className="flex gap-3">
                                    <div className="rounded-[40px] w-fit bg-lightGreen p-2 px-3">
                                      <p className="text-xs font-medium leading-5 text-text2">
                                        360 User
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </>
                      )
                    })}
                  </div>
                )}
              </div>
            </div>
          </>
        </div>
      </div>
      <Modal
        customStyle={{ borderRadius: 16, width: '480px' }}
        isOpen={isOpen}
        onClose={handleCloseModal}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center px-4 py-2  flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="w-full p-4 bg-gray1 rounded-xl flex">
            <div className="flex-1">
              <p className="text-sm font-semibold leading-6 text-text4">
                Do you want to send email ?
              </p>
            </div>
            <div>
              <UISwitch
                value={isEmailSend}
                onValueChange={(e) => {
                  setIsEmailSend(e)
                }}
              />
            </div>
          </div>
          <div className="w-full mt-4">
            <UIButton
              loading={isEmailSendLoader}
              // disabled={checkValidation(formData)}
              label={'Confirm'}
              onClick={() => {
                handleVerifyUser(isEmailSend, userId, 'Completed')
              }}
            />
          </div>
        </div>
      </Modal>
    </>
  )
}

export default Users
